(function () {
  if (!document.body.classList.contains('template--product')) return;

  function bind(card) {
    if (card.getAttribute('data-kg-bound') === 'true') return;
    card.setAttribute('data-kg-bound', 'true');
    var body = card.querySelector('[data-kg-desc-body]');
    var toggle = card.querySelector('[data-kg-desc-toggle]');
    var more = card.querySelector('.kg-desc__toggle-more');
    var less = card.querySelector('.kg-desc__toggle-less');
    if (!body || !toggle) return;

    function setExpanded(expanded) {
      body.classList.toggle('is-collapsed', !expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (more) more.hidden = expanded;
      if (less) less.hidden = !expanded;
    }

    toggle.addEventListener('click', function () {
      setExpanded(body.classList.contains('is-collapsed'));
    });
  }

  document.querySelectorAll('[data-kg-desc]').forEach(bind);
})();
